import React from 'react';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Card from 'components/Card/Card.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardBody from 'components/Card/CardBody.js';
import { Assignment } from '@material-ui/icons';
import { nDecimal } from 'hooks/Pipe';

const intangibleTypes = [
  { code: 'N', name: 'Ninguno' },
  { code: '01', name: 'Intangible adquirido' },
  { code: '02', name: 'Intagieble en etapa de investigación' },
  { code: '03', name: 'En etapa de desarrollo' },
  { code: null, name: '-' }
];

export default function ReadSaleDate(props) {
  const { dataProduct } = props;

  return (
    <>
      <GridItem xs={12} lg={4} xl={4}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Gestión</h4>
          </CardHeader>
          <CardBody>
            <h6>Nombre de artículo de Origen</h6>
            <p>{dataProduct.U_SYP_NOM_OR_REV || '-'}</p>
            <h6>Artículo gestionado por serie</h6>
            <p>{dataProduct.ManSerNum == 'Y' ? 'Si' : dataProduct.ManSerNum == 'N' ? 'No' : '-'}</p>
            <h6>Artículo gestionado por lotes</h6>
            <p>
              {dataProduct.ManBtchNum == 'Y' ? 'Si' : dataProduct.ManBtchNum == 'N' ? 'No' : '-'}
            </p>
            <h6>Artículo de revaluación</h6>
            <p>
              {dataProduct.U_SYP_ES_REVAL == 'Y'
                ? 'Si'
                : dataProduct.U_SYP_ES_REVAL == 'N'
                ? 'No'
                : '-'}
            </p>
          </CardBody>
        </Card>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>SUNAT</h4>
          </CardHeader>
          <CardBody>
            <h6>Uni. medida SUNAT</h6>
            <p>{dataProduct.U_SYP_TIPUNMED}</p>
            <h6>Catálogo de existencia SUNAT</h6>
            <p>{dataProduct.U_SYP_CATEXIST1}</p>
            <h6>Catálogo de existencia</h6>
            <p>{dataProduct.U_SYP_CATEXIST}</p>
            <h6>Servicio público</h6>
            <p>
              {dataProduct.U_SYP_SERVPUBLICO === 'Y'
                ? 'Si'
                : dataProduct.U_SYP_SERVPUBLICO === 'N'
                ? 'No'
                : '-'}
            </p>
            <h6>Requiere ICBPER</h6>
            <p>
              {dataProduct.U_SYP_ICBPER === 'Y'
                ? 'Si'
                : dataProduct.U_SYP_ICBPER === 'N'
                ? 'No'
                : '-'}
            </p>
          </CardBody>
        </Card>
      </GridItem>
      <GridItem xs={12} lg={8} xl={8}>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Impuestos</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={6}>
                <h6>Cod. Detracción</h6>
                <p>CIE-10</p>
                {/* <h6>Impuesto acreedores</h6> //se comento xq no se encontro sentido
                <p>
                  {dataProduct.TaxCodeAR == 'Y' ? 'Si' : dataProduct.TaxCodeAR == 'N' ? 'No' : '-'}
                </p> */}
                <h6>Sujeto a retención de impuestos</h6>
                <p>
                  {dataProduct.WTLiable == 'Y' ? 'Si' : dataProduct.WTLiable == 'N' ? 'No' : '-'}
                </p>
              </GridItem>
              <GridItem xs={12} lg={6} xl={6}>
                <h6>Sujeto a impuestos</h6>
                <p>
                  {dataProduct.VATLiable == 'Y' ? 'Si' : dataProduct.VATLiable == 'N' ? 'No' : '-'}
                </p>
                <h6>Impuesto indirecto</h6>
                <p>
                  {dataProduct.IndirctTax == 'Y'
                    ? 'Si'
                    : dataProduct.IndirctTax == 'N'
                    ? 'No'
                    : '-'}
                </p>
                <h6>No va cuenta de aspectos diferidos</h6>
                <p>
                  {dataProduct.U_SYP_CTAVTAD == 'Y'
                    ? 'Si'
                    : dataProduct.U_SYP_CTAVTAD == 'N'
                    ? 'No'
                    : '-'}
                </p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
        <Card>
          <CardHeader icon>
            <CardIcon color="primary">
              <Assignment />
            </CardIcon>
            <h4 style={{ color: 'black' }}>Otros</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} lg={6} xl={6}>
                <h6>Tipo de existencia</h6>
                <p>{dataProduct.U_SYP_TIPEXIST || '-'}</p>
                <h6>Tipo intangible</h6>
                <p>
                  {
                    intangibleTypes.find((item) => item.code === dataProduct.U_SYP_TIPOINTANGIBLE)
                      ?.name
                  }
                </p>
                <h6>Descripción Naciones Unidas</h6>
                <p>{dataProduct.U_SYP_UNSPSCDES || '-'}</p>
                <h6>Descripción CUBSO</h6>
                <p>{dataProduct.U_SYP_CUBSODES || '-'}</p>
                <h6>Nombre de padre</h6>
                <p>{dataProduct.U_SYP_NOM_PADRE || '-'}</p>
                <h6>Combustible</h6>
                <p>
                  {dataProduct.U_SYP_COMBUST === 'Y'
                    ? 'Si'
                    : dataProduct.U_SYP_COMBUST === 'N'
                    ? 'No'
                    : '-'}
                </p>
              </GridItem>
              <GridItem xs={12} lg={6} xl={6}>
                <h6>Tope de percepción</h6>
                <p>{nDecimal(dataProduct.U_SYP_TOPE)}</p>
                <h6>Afecto a percepción</h6>
                <p>
                  {dataProduct.U_SYP_APER === 'Y'
                    ? 'Si'
                    : dataProduct.U_SYP_APER === 'N'
                    ? 'No'
                    : '-'}
                </p>
                <h6>Cód. Naciones Unidas</h6>
                <p>{dataProduct.U_SYP_UNSPSC || '-'}</p>
                <h6>Cód. CUBSO</h6>
                <p>{dataProduct.U_SYP_CUBSO || '-'}</p>
                <h6>Cód. de padre</h6>
                <p>{dataProduct.U_SYP_COMP_PADRE || '-'}</p>
                <h6>Gas licuado de petróleo</h6>
                <p>
                  {dataProduct.U_SYP_GLP === 'Y'
                    ? 'Si'
                    : dataProduct.U_SYP_GLP === 'N'
                    ? 'No'
                    : '-'}
                </p>
              </GridItem>
            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    </>
  );
}
